import React from "react";
import PropTypes from "prop-types";
import moment from 'moment';
import 'moment-timezone';
import './styles/main';

import DateTimePicker from '@components/common/date_time_picker/main';
import Checkbox from '@components/common/checkbox/main';
import { bulkRefreshSections, pluralizeObject } from '@helpers//show_page_helpers';


class AssetAvailability extends React.Component {
  state = {
    availability_end_date: this.availabilityEnd,
    availability_end_time: this.availabilityEndTime,
    availability_end_zone: moment.tz.guess(),
    availability_start_date: this.availabilityStart,
    availability_start_time: this.availabilityStartTime,
    availability_start_zone: moment.tz.guess(),
    disableSubmitButton: true,
    neverExpire: !this.props.availabilityEnd,
    publishNow: !this.props.availabilityStart
  }

  get availabilityEnd() {
    return this.props.availabilityEnd
      ? moment(this.props.availabilityEnd).format('MM/DD/YYYY')
      : moment().add(7, 'days').format('ll');
  }

  get availabilityEndTime() {
    return this.props.availabilityEnd
      ? moment(this.props.availabilityEnd).format('hh:mm a')
      : '11:59 pm';
  }

  get availabilityStart() {
    return this.props.availabilityStart
      ? moment(this.props.availabilityStart).format('MM/DD/YYYY')
      : moment().add(1, 'days').format('ll');
  }

  get availabilityStartTime() {
    return this.props.availabilityStart
      ? moment(this.props.availabilityStart).format('hh:mm a')
      : '12:01 am';
  }

  availability_start = () => {
    const { availability_start_date, availability_start_time } = this.state;
    let { availability_start_zone } = this.state;

    availability_start_zone = availability_start_zone || moment.tz.guess();
    return moment.tz(`${availability_start_date} ${availability_start_time}`, 'MM/DD/YYYY hh:mm a', availability_start_zone);
  }

  availability_end = () => {
    const { availability_end_date, availability_end_time } = this.state;
    let { availability_end_zone } = this.state;

    availability_end_zone = availability_end_zone || moment.tz.guess();
    return moment.tz(`${availability_end_date} ${availability_end_time}`, 'MM/DD/YYYY hh:mm a', availability_end_zone);
  }

  buildDataBody = () => {
    const { neverExpire, publishNow } = this.state;

    return {
      data: {
        asset_keys: Array.from(this.props.selectedAssetKeys),
        asset_availability: {
          availability_start: (publishNow ? null : this.availability_start().format()),
          availability_end: (neverExpire ? null : this.availability_end().format())
        }
      }
    };
  }

  updateAvailability = () => {
    const { activeCdnTracers, bulk, updateLoading } = this.props;
    this.setState({ disableSubmitButton: true });
    if (updateLoading) { updateLoading(); }

    if ((this.state.neverExpire === false || this.state.publishNow === false) && activeCdnTracers && activeCdnTracers > 0) {
      const that = this;
      const title = bulk ? t("An asset has external links.") : t("This asset has external links.");
      const textintro = bulk ? t("At least one of your selected assets has external links. ") : "";
      const text = `${textintro} ${t('This will cause broken image links on sites that depend on the availability of these assets. Check the usage tab to see active external links before changing availability..\n\n')}`;
      const sweet_alert_options = {
        title,
        text,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: t("Cancel"),
        confirmButtonText: t("Update"),
        closeOnConfirm: true,
        customClass: "merging"
      };

      window.swal(sweet_alert_options, (update_selected) => {
        if (update_selected) {
          that.sendAvailability();
        } else {
          that.setState({ disableSubmitButton: false });
        }
      });
    } else {
      this.sendAvailability();
    }
  }

  sendAvailability = () => {
    const url = '/api/v4/bulk_actions/assets/availability';
    const assetQtyObject = pluralizeObject(this.props.selectedAssetKeys);
    const dataObject = this.buildDataBody();
    $.ajax({
      type: "PUT",
      url,
      contentType: "application/json",
      data: JSON.stringify(dataObject),
      context: this,
      headers: { Authorization: `Bearer ${BF_Token}` },
      success: () => {
        this.props.updateAvailabilityStatus(dataObject.data.asset_availability);
        bulkRefreshSections(this.props.selectedAssetKeys);
        if (this.props.closeModal) {
          this.props.closeModal();
        } else { this.setState({ disableSubmitButton: true }); }
        const assetCopy = assetQtyObject.plural ? t('assets') : t('asset');

        Notify.create({
          title: `${t('Availability updated for')} ${assetQtyObject.qty} ${assetCopy}!`,
          type: 'success'
        });
      },
      error: () => {
        this.setState({ disableSubmitButton: false });
        if (this.props.updateLoading) { this.props.updateLoading(); }
        Notify.create({
          title: t('An error occurred when updating asset availability. Please try again.'),
          type: 'error'
        });
      }
    });
  }

  updateDateTimeStart = (availability_start_date, availability_start_time, availability_start_zone) => {
    this.setState({
      availability_start_date,
      availability_start_time,
      availability_start_zone
    }, () => this.enableActionButton());
  }

  updateDateTimeEnd = (availability_end_date, availability_end_time, availability_end_zone) => {
    this.setState({
      availability_end_date,
      availability_end_time,
      availability_end_zone
    }, () => this.enableActionButton());
  }

  toggleCheckBoxExpire = () => {
    const { neverExpire } = this.state;
    this.setState({ neverExpire: !neverExpire }, () => this.enableActionButton());
  }

  toggleCheckBoxPublish = () => {
    const { publishNow } = this.state;
    this.setState({ publishNow: !publishNow }, () => this.enableActionButton());
  }

  enableActionButton = () => {
    const { neverExpire, publishNow } = this.state;
    let enabled = true;

    if (neverExpire && publishNow) { // both boxes checked
      enabled = true;
    } else if (!neverExpire && !publishNow) { // both boxes unchecked
      if (this.availability_start().isValid() && this.availability_end().isValid()) {
        enabled = this.availability_start().isBefore(this.availability_end()); // is expire date after than publish date
      } else {
        enabled = false;
      }
    } else if (!publishNow) {
      enabled = this.availability_start().isValid();
    } else if (!neverExpire) {
      enabled = this.availability_end().isValid();
    } else {
      enabled = false;
    }

    this.setState({ disableSubmitButton: !enabled });
  }

  closeModalOrReset = () => {
    if (this.props.closeModal) {
      this.props.closeModal();
    } else {
      this.setState({
        availability_end_date: moment().add(7, 'days').format('ll'),
        availability_end_time: '11:59 pm',
        availability_end_zone: moment.tz.guess(),
        availability_start_date: this.availabilityStart,
        availability_start_time: this.availabilityStartTime,
        availability_start_zone: moment.tz.guess(),
        disableSubmitButton: false,
        isLoading: false,
        neverExpire: !this.props.availabilityEnd,
        publishNow: !this.props.availabilityStart
      });
    }
  }

  render() {
    const {
      availability_start_date, availability_start_time, availability_start_zone,
      availability_end_date, availability_end_time, availability_end_zone, disableSubmitButton,
      neverExpire, publishNow
    } = this.state;
    const disabledClassExpires = neverExpire ? 'disabled-section' : '';
    const disabledClassPublish = publishNow ? 'disabled-section' : '';

    return (
      <div className="asset-availability">
        <div className={`modal-row ${disabledClassPublish} availability-start-dateTimePicker`}>
          <h4 className="row-title">
            {t('Set publish date (restrict access')}&nbsp;
            <span className="bold-text">{t('until')}</span>&nbsp;
            {t('this date)')}
          </h4>
          <DateTimePicker
            selectedDate={availability_start_date}
            selectedTime={availability_start_time}
            selectedZone={availability_start_zone}
            updateDateTime={this.updateDateTimeStart}
          />
        </div>
        <div className="checkbox-container">
          <Checkbox
            size="sm"
            checked={publishNow}
            toggle={() => this.toggleCheckBoxPublish()}
            labelHtml={<h5>{t(' Publish now ')}</h5>}
          />
        </div>
        <hr />

        <div className={`modal-row ${disabledClassExpires} availability-end-dateTimePicker`}>
          <h4 className="row-title">
            {t('Set expiration date (restrict access')}&nbsp;
            <span className="bold-text">{t('after')}</span>&nbsp;
            {t('this date)')}
          </h4>
          <DateTimePicker
            selectedDate={availability_end_date}
            selectedTime={availability_end_time}
            selectedZone={availability_end_zone}
            updateDateTime={this.updateDateTimeEnd}
          />
        </div>
        <div className="checkbox-container">
          <Checkbox
            size="sm"
            checked={neverExpire}
            toggle={() => this.toggleCheckBoxExpire()}
            labelHtml={<h5>{t(' Never expire ')}</h5>}
          />
        </div>

        <div className="button-container">
          <button
            className="button tertiary sm t-close-modal"
            onClick={this.closeModalOrReset}
            type="button"
          >
            {t('Cancel')}
          </button>
          <button
            className="button sm primary t-confirm-modal"
            disabled={disableSubmitButton}
            onClick={this.updateAvailability}
            type="button"
          >
            {t('Save')}
          </button>
        </div>
      </div>
    );
  }
}

AssetAvailability.propTypes = {
  availabilityEnd: PropTypes.string,
  availabilityStart: PropTypes.string,
  bulk: PropTypes.bool,
  closeModal: PropTypes.func,
  activeCdnTracers: PropTypes.number,
  selectedAssetKeys: PropTypes.instanceOf(Set).isRequired,
  updateLoading: PropTypes.func,
  updateAvailabilityStatus: PropTypes.func
};

AssetAvailability.defaultProps = {
  updateAvailabilityStatus: () => {}
};

export default AssetAvailability;
